module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcCAYAAAAAwr0iAAAAAXNSR0IArs4c6QAAANpJREFUSEvN17ENwjAQBdB/Yg0WoqOjYAamYAt6CiQKdmKO6CNLieQiUu7O/xTSxrr/7Chn2zD4kDwBeMxlbmb2iZS0yOC1sSS/AI7zuwnA1cxe3rpqQMsNIRSAM4A3gEM3azdiGNBCSV4APDMICWAEIQNkEVJABiEHRBElgAiiDOBFlAI8COt6+dJOvV1UMe7eAH0vVxSN1Jj+ArBsp/t8gsh6ZcZu7ROlf8FWeJtQGcATXgbwhpcAIuFyQDRcCsiEywDZcAmA5L6H0pW9xH0iVq3A7heToavZDzuLoQ3c6VTAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/right.png
// module id = JfLI
// module chunks = 1